import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * MachFormEdit - Page wrapper for editing filled Machinery forms
 * Used for navigation in routes/index.tsx
 */
const MachFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default MachFormEdit;
